import { useTranslation } from 'react-i18next'
import { Box } from '@mantine/core'

import classes from '../LogVolunteeringActivityForm/LogVolunteeringActivityForm.module.scss'

import { SelectOptionCard } from '@percent/domain/volunteering'
import { VolunteeringTimeLogType } from '@percent/workplace-giving/api/opportunity/dto'

type PlatformSelectorProps = {
  value: VolunteeringTimeLogType
  onChange: (platform: VolunteeringTimeLogType) => void
}

export function PlatformSelector({ value, onChange }: Readonly<PlatformSelectorProps>) {
  const { t } = useTranslation()

  return (
    <Box className={classes.OptionsCardsBox}>
      <SelectOptionCard
        testId="offPlatformVariant"
        badge={t('workplace_giving.common.offPlatform')}
        title={t('workplace_giving.volunteering.activityForm.offPlatformLabel')}
        description={t('workplace_giving.volunteering.activityForm.offPlatformDescription')}
        active={value === VolunteeringTimeLogType.OffPlatform}
        onClick={() => onChange(VolunteeringTimeLogType.OffPlatform)}
      />
      <SelectOptionCard
        testId="onPlatformVariant"
        badge={t('workplace_giving.common.onPlatform')}
        title={t('workplace_giving.volunteering.activityForm.onPlatformLabel')}
        description={t('workplace_giving.volunteering.activityForm.onPlatformDescription')}
        active={value === VolunteeringTimeLogType.OnPlatform}
        onClick={() => onChange(VolunteeringTimeLogType.OnPlatform)}
      />
    </Box>
  )
}
